/** Only set by the theme toggle — first visit / no key = always light. */
export const THEME_STORAGE_KEY = 'shejza-theme'

export function readStoredThemeIsDark(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(THEME_STORAGE_KEY) === 'dark'
  } catch {
    return false
  }
}

export function applyThemeToDocument(isDark: boolean) {
  document.documentElement.classList.toggle('dark', isDark)
}
